import {
  DELETE_PROFILE,
  UPDATE_PROFILE,
  UPDATE_AUTHSTATE,
  UPDATE_AUTHDATA,
  USER_PRIVILEGES_GET,
  USER_PRIVILEGES_GET_SUCCESS,
  USER_PRIVILEGES_GET_ERROR,
  SET_AMPLIFY_CONFIG_STATUS,
  WEBPUSH_PERMISSION_START,
  WEBPUSH_PERMISSION_ERROR,
  WEBPUSH_PERMISSION_SUCCESS
} from "../actions";

const INIT_STATE = {
  user: {},
  authState: "signIn",
  authData: {},
  userPrivileges: {},
  isUserPrivilegesLoading: false,
  isAmplifyConfigured: false,
  webPushError: null
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case USER_PRIVILEGES_GET:
      return { ...state, isUserPrivilegesLoading: true };
    case USER_PRIVILEGES_GET_SUCCESS:
      if (action.payload && Object.keys(action.payload).length > 0) {
        return {
          ...state,
          isUserPrivilegesLoading: false,
          userPrivileges: action.payload,
          isAuthorized: true
        };
      }
      return {
        ...state,
        isUserPrivilegesLoading: false,
        userPrivileges: action.payload,
        isAuthorized: false
      };

    // const isAuthorized = ((action.payload && Object.keys(action.payload).lenght > 0) ? true: false);
    // return { ...state, isUserPrivilegesLoading: false, userPrivileges: action.payload, isAuthorized: false };
    case USER_PRIVILEGES_GET_ERROR:
      return { ...state, isUserPrivilegesLoading: false, userPrivileges: {}, error: action.payload };
    case UPDATE_PROFILE:
      return { ...state, profile: action.payload };
    case UPDATE_AUTHSTATE:
      return { ...state, authState: action.payload };
    // return { ...state, authState: action.payload , isAuthorized: true };

    case SET_AMPLIFY_CONFIG_STATUS:
      return { ...state, isAmplifyConfigured: action.payload };
    case UPDATE_AUTHDATA:
      return { ...state, authData: action.payload };
    case DELETE_PROFILE:
      return { ...state, profile: null };
    case WEBPUSH_PERMISSION_START:
      return { ...state, webPushError: null };
    case WEBPUSH_PERMISSION_ERROR:
      return { ...state, webPushError: action.payload };
    case WEBPUSH_PERMISSION_SUCCESS:
      return { ...state, webPushError: null };
    default:
      return state;
  }
};
